import { FC, SetStateAction } from 'react';
import Flex from './Flex';
import StyledInput from './formElements/StyledInput';
import Box from './primitives/Box';

type Props = {
  placeholder?: string;
  setSearchTerm: SetStateAction<any>;
};

const SearchBox: FC<Props> = props => {
  return (
    <Flex size="1" direction="row" alignItems="center" px={4}>
      <Flex size="0.25" direction="row">
        <Box width="100%">
          <StyledInput
            type="text"
            id="searchTerm"
            aria-label="Search"
            onChange={(event: any) => props.setSearchTerm(event.target.value)}
            placeholder={props.placeholder || 'Search...'}
            px={2}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default SearchBox;
